function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import MenuIcon from '@material-ui/icons/MenuSharp';
import CloseIcon from '@material-ui/icons/CloseSharp';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import classNames from 'classnames';
import WindowTopMenuButton from '../containers/WindowTopMenuButton';
import WindowTopBarPluginArea from '../containers/WindowTopBarPluginArea';
import WindowTopBarPluginMenu from '../containers/WindowTopBarPluginMenu';
import WindowTopBarTitle from '../containers/WindowTopBarTitle';
import MiradorMenuButton from '../containers/MiradorMenuButton';
import FullScreenButton from '../containers/FullScreenButton';
import WindowMaxIcon from './icons/WindowMaxIcon';
import WindowMinIcon from './icons/WindowMinIcon';
import ns from '../config/css-ns';
/**
 * WindowTopBar
 */

export var WindowTopBar = /*#__PURE__*/function (_Component) {
  _inherits(WindowTopBar, _Component);

  var _super = _createSuper(WindowTopBar);

  function WindowTopBar() {
    _classCallCheck(this, WindowTopBar);

    return _super.apply(this, arguments);
  }

  _createClass(WindowTopBar, [{
    key: "render",
    value:
    /**
     * render
     * @return
     */
    function render() {
      var _this$props = this.props,
          removeWindow = _this$props.removeWindow,
          windowId = _this$props.windowId,
          classes = _this$props.classes,
          toggleWindowSideBar = _this$props.toggleWindowSideBar,
          t = _this$props.t,
          windowDraggable = _this$props.windowDraggable,
          maximizeWindow = _this$props.maximizeWindow,
          maximized = _this$props.maximized,
          minimizeWindow = _this$props.minimizeWindow,
          focused = _this$props.focused,
          allowClose = _this$props.allowClose,
          allowMaximize = _this$props.allowMaximize,
          focusWindow = _this$props.focusWindow,
          allowFullscreen = _this$props.allowFullscreen,
          allowTopMenuButton = _this$props.allowTopMenuButton,
          allowWindowSideBar = _this$props.allowWindowSideBar;
      return /*#__PURE__*/React.createElement(AppBar, {
        position: "relative",
        color: "default"
      }, /*#__PURE__*/React.createElement("nav", {
        "aria-label": t('windowNavigation')
      }, /*#__PURE__*/React.createElement(Toolbar, {
        disableGutters: true,
        onMouseDown: focusWindow,
        className: classNames(classes.windowTopBarStyle, windowDraggable ? classes.windowTopBarStyleDraggable : null, focused ? classes.focused : null, ns('window-top-bar')),
        variant: "dense"
      }, allowWindowSideBar && /*#__PURE__*/React.createElement(MiradorMenuButton, {
        "aria-label": t('toggleWindowSideBar'),
        onClick: toggleWindowSideBar
      }, /*#__PURE__*/React.createElement(MenuIcon, null)), /*#__PURE__*/React.createElement(WindowTopBarTitle, {
        windowId: windowId
      }), allowTopMenuButton && /*#__PURE__*/React.createElement(WindowTopMenuButton, {
        className: ns('window-menu-btn'),
        windowId: windowId
      }), /*#__PURE__*/React.createElement(WindowTopBarPluginArea, {
        windowId: windowId
      }), /*#__PURE__*/React.createElement(WindowTopBarPluginMenu, {
        windowId: windowId
      }), allowMaximize && /*#__PURE__*/React.createElement(MiradorMenuButton, {
        "aria-label": maximized ? t('minimizeWindow') : t('maximizeWindow'),
        className: ns('window-maximize'),
        onClick: maximized ? minimizeWindow : maximizeWindow
      }, maximized ? /*#__PURE__*/React.createElement(WindowMinIcon, null) : /*#__PURE__*/React.createElement(WindowMaxIcon, null)), allowFullscreen && /*#__PURE__*/React.createElement(FullScreenButton, null), allowClose && /*#__PURE__*/React.createElement(MiradorMenuButton, {
        "aria-label": t('closeWindow'),
        className: ns('window-close'),
        onClick: removeWindow
      }, /*#__PURE__*/React.createElement(CloseIcon, null)))));
    }
  }]);

  return WindowTopBar;
}(Component);
WindowTopBar.defaultProps = {
  allowClose: true,
  allowFullscreen: false,
  allowMaximize: true,
  allowTopMenuButton: true,
  allowWindowSideBar: true,
  focused: false,
  focusWindow: function focusWindow() {},
  maximized: false,
  maximizeWindow: function maximizeWindow() {},
  minimizeWindow: function minimizeWindow() {},
  t: function t(key) {
    return key;
  },
  windowDraggable: true
};